import Grid from '@mui/material/Grid';
import React from 'react';
import styled from 'styled-components';
import { ModalComponent } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import PlantillaPdfPlanEvaluacion from '../plantilla/PlantillaPdfPlanEvaluacion';

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const SettingsPlanEvaluacion = () => {
  const [openModalPlantillaPdf, setOpenModalPlantillaPdf] =
    React.useState(false);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} ms={12}>
        <BotonComponent
          fullWidth
          click={() => {
            setOpenModalPlantillaPdf(true);
          }}
          green
          mr={2}
          text="Descargar plantilla PDF"
          downloadIcon
        />
      </Grid>
      <ModalComponent
        id="modal-pdf-plan-evaluacion"
        title="Plantilla PDF de plan de evaluación"
        open={openModalPlantillaPdf}
        maxWidth="lg"
        onClose={() => setOpenModalPlantillaPdf(!openModalPlantillaPdf)}
      >
        <PlantillaPdfPlanEvaluacion />
      </ModalComponent>
    </Grid>
  );
};

export default SettingsPlanEvaluacion;
